export {getInjection} from '@runlab/web/src/config/di/container'
export {DI, DI_VARIATIONS} from '@runlab/web/src/config/di/types'
export type {DI_RETURN_TYPES} from '@runlab/web/src/config/di/return-types'
